module.exports = __webpack_public_path__ + "static/google-ads-logo-155383c5f2c8a9d704c79c1f29d2c98b.png";